import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}> 
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function ChenilleEmbroideryDigitizing() {

    const chenilleSteps = [
        { number: "01", title: "Submit Your Design", description: "Send your logo, patch, or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Chenille Digitizing", description: "We convert your design into a machine-ready stitch file optimized for chenille embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Check", description: "We refine stitch density, loop placement, and underlay for clean, textured results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, or other formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Chenille Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Premium chenille embroidery digitizing services in Los Angeles, CA. Perfect for varsity patches and textured embroidery designs." />
                <meta name="keywords" content="chenille embroidery digitizing, chenille patch digitizing, chenille logo digitizing, embroidery digitizing Los Angeles, chenille digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Chenille Embroidery Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Chenille Embroidery Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/chemille1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Bold Texture. Vintage Appeal.</span>
                                <h3 className="case-study-title">Expert Chenille Embroidery Digitizing in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized chenille embroidery digitizing services in Los Angeles, California, helping businesses, schools, and sports teams create bold, textured embroidery designs. Chenille embroidery requires precise digitizing to ensure each loop stitch forms properly, giving your design the classic raised, fuzzy appearance.
                                </p>
                                <p className="case-study-description">
                                    Our team converts logos, patches, and custom artwork into high-quality stitch files optimized for chenille embroidery. Whether it’s varsity letters, sports patches, or unique textured logos, our chenille embroidery digitizing services guarantee clean, professional results. If you’re searching for reliable chenille digitizing near you in Los Angeles, Grand Indigo Embroidery delivers superior quality, consistency, and machine-ready files every time.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Engineered for Chenille Machines</span>
                                <h3 className="case-study-title">Custom Chenille Digitizing for Patches & Apparel</h3>
                                <p className="case-study-description">
                                    Our custom chenille embroidery digitizing services are designed for schools, teams, clubs, and fashion brands that want high-quality, textured embroidery. We optimize stitch paths, density, and sequencing to ensure your design maintains its shape, texture, and integrity during production.
                                </p>
                                <p className="case-study-description">
                                    From small patches to large varsity designs, we provide fully production-ready files compatible with all major embroidery machines. Businesses in Los Angeles trust Grand Indigo Embroidery for fast turnaround, accuracy, and professional chenille digitizing. You can also order chenille embroidery digitizing online to get ready-to-use files quickly.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/chemille2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={chenilleSteps} />
                                                
            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is chenille embroidery digitizing?"
                                    answer="Chenille embroidery digitizing is the process of converting designs into machine-readable stitch files for creating textured, looped embroidery such as varsity letters or patches."
                                />

                                <FaqItem
                                    question="Do you offer chenille digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional chenille embroidery digitizing services in Los Angeles, California."
                                />

                                <FaqItem
                                    question="Can I order chenille embroidery digitizing online?"
                                    answer="Absolutely. You can easily order chenille embroidery digitizing online and receive optimized files quickly."
                                />

                                <FaqItem
                                    question="What types of designs work best for chenille embroidery?"
                                    answer="Bold logos, letters, varsity patches, and designs requiring texture work best for chenille embroidery."
                                />

                                <FaqItem
                                    question="What garments or items can use chenille embroidery?"
                                    answer="Chenille embroidery can be applied to jackets, hats, patches, sweaters, and sports apparel."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
